import React from 'react'
import { PositionCell as SharedPositionCell } from '../../../../shared/ui/cells/PositionCell'
import { IconArrowDown } from '../../../../shared/components/icons/IconArrowDown'

interface PositionCellProps {
  position: number
  previous_position: number | null
}

export const PositionCell = ({ position, previous_position }: PositionCellProps) => {
  const current = +position.toFixed(1)
  const previous = previous_position !== null && +previous_position.toFixed(1)

  if (!current && previous) {
    return (
      <div className='flex items-center gap-2'>
        <span className='w-8'>&gt;10</span>
        <span className='flex items-center text-danger'>
          <IconArrowDown className='w-4' color='#DC2F02' />
          {11 - previous}
        </span>
      </div>
    )
  } else if (!current) {
    return <span className={'text-danger'}>Lost</span>
  }

  return <SharedPositionCell current={current} previous={previous} />
}
